import { CanDeactivateFn } from "@angular/router";
import { CanComponentDeactivate } from "@itm/types/guards.types";

export const canDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = (component: CanComponentDeactivate) => {
    return component?.canDeactivate ? component?.canDeactivate() : true;
  };